module.exports = __webpack_public_path__ + "img/img_1_b_.e3c2b3ac.png";